import { render, staticRenderFns } from "./trillAddress.vue?vue&type=template&id=1677943a&"
import script from "./trillAddress.vue?vue&type=script&lang=js&"
export * from "./trillAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports